import { connect } from 'react-redux';
import FriendsInterestedSection from './Friends_interested_section';
import { getFriendsInterested } from '../friends_actions';

const mDTP = { getFriendsInterested };

export default connect(null, mDTP)(FriendsInterestedSection);
